import type { FC } from 'react';
import type { Theme } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { SxProps } from '@material-ui/system';
import { ReactComponent as ImagenDark } from '../assets/img/Avatar-P-Prior.svg';

interface LogoProps {
  sx?: SxProps<Theme>;
}

const LogoRoot = experimentalStyled('svg')();

const LogoP: FC<LogoProps> = (props) => (
  <LogoRoot height="52" version="1.1" viewBox="0 0 20 50" width="50" {...props}>
    <title>Prior</title>
    <ImagenDark />
  </LogoRoot>
);

export default LogoP;
